import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/styles/globals.css'
import App from './App.tsx'
import { initSentry } from '@/lib/sentry'
import { installChunkReload } from '@/lib/chunkReload'

void initSentry('dashboard-ui')
installChunkReload()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
